/**
 * Vehicle Search Dynamic Filters
 * Always uses search page for filter data
 * Works on any page type (collection, search, home, product, etc.)
 */
const COLOR_HEX_MAP = {
  "Azurite Blue Pearl": "#1e3f73",
  "Burnished Bronze Metallic": "#6e4a2c",
  "Carbide Gray Metallic": "#4a4f55",
  "Crystal Black Silica": "#000000",
  "Crystal Black Silica Pearl": "#111111",
  "Crystal White": "#ffffff",
  "Crystal White Pearl": "#f8f8f8",
  "Crystal White Tricoat": "#f4f4f4",
  "Dark Gray Metalli": "#5c5c5c",
  "Dark Gray Metallic": "#5c5c5c",
  "Dark Grey Metallic": "#5c5c5c",
  "Deep Bronze Metallic": "#4b3621",
  "Deep Indigo Pearl": "#1e2044",
  "Ice Silver Metallic": "#bec2cb",
  "Island Blue Pearl": "#005a9c",
  "Lapis Blue Pearl": "#1e2044",
  "Magnetite Gray Metallic": "#353839",
  "Quartz Silver Metallic": "#a2a2a1",
  "Red Brick Metallic": "#8b0000",
  "Satin White Pear": "#f5f5f5",
  "Satin White Pearl": "#f5f5f5",
  "Satin White Pearl Tricoat": "#f5f5f5",
  "Sky Blue Metallic": "#87ceeb",
  "Solar Orange": "#ff4500",
  "Spark Silver Metallic": "#bdc3c7",
  "Sunshine Orange": "#ff8c00",
  "Tungsten Metallic": "#948d81",
  "Twilight Blue Metallic": "#5b7c91",
  "Venetian Red Pearl": "#7b0101",
  "World Rally Blue Pearl": "#0033cc"
};

function applyColorData() {

  // Preview circles
  $('.color-circle').each(function() {
    let label = $(this).data('label');
    if (!label) return;

    label = label.trim().toLowerCase();

    let matched = false;

    for (const key in COLOR_HEX_MAP) {
      if (key.trim().toLowerCase() === label) {
        $(this).css('background-color', COLOR_HEX_MAP[key]);
        matched = true;
        break;
      }
    }

    if (!matched) {
      $(this).css('background-color', '#cccccc');

    }
  });

  // Popup items
  $('.color-popup-item').each(function() {
    let label = $(this).data('label');
    if (!label) return;

    label = label.trim().toLowerCase();

    let matched = false;

    for (const key in COLOR_HEX_MAP) {
      if (key.trim().toLowerCase() === label) {
        $(this).find('.popup-swatch')
          .css('background-color', COLOR_HEX_MAP[key]);

        matched = true;
        break;
      }
    }

    if (!matched) {
      $(this).find('.popup-swatch')
        .css('background', '#e0e0e0'); // fallback
    }

    if (window.COLOR_META_MAP) {
      for (const metaKey in window.COLOR_META_MAP) {
        if (metaKey.trim().toLowerCase() === label) {
          $(this).find('.popup-code')
            .text(window.COLOR_META_MAP[metaKey]);
          break;
        }
      }
    }
  });

}







(function($) {
  'use strict';

  const VehicleSearch = {
    
    // Configuration
    config: {
      formSelector: '#vehicle-search-form',
      containerSelector: '#vehicle-search-bar',
      filterSelector: '.vs-filter',
      colorFilterSelector: '.color-filter',
      submitButtonSelector: '.vs-submit-btn',
      resetButtonSelector: '.vs-clear-btn',
      searchPageUrl: '/search',
      collectionPageUrl: '/collections/all',
      viewParam: '', //view=filters
      debounceDelay: 300
    },

    // State management
    state: {
      isLoading: false,
      debounceTimer: null
    },

    /**
     * Initialize the vehicle search functionality
     */
    init: function() {
      this.bindEvents();
      console.log('Vehicle Search initialized - Always using search page for filters');
    },

    /**
     * Bind event listeners
     */
    bindEvents: function() {
      const self = this;
      const page = location.pathname;
      if(!(page.includes('search') || page.includes('collection'))){
        setTimeout(function(){self.handleFilterChange('')},1000)
      }
      // Year and Model select changes
      $(document).on('change', 'select.vs-filter', function() {
        self.handleFilterChange($(this));
      });

      // Color radio button changes
      $(document).on('change', 'input.color-filter', function() {
        self.handleFilterChange($(this));
      });
// CLICK PREVIEW CIRCLE
$(document).on('click', '.color-circle', function() {
  const target = $(this).data('target');

  $('#' + target).prop('checked', true).trigger('change');

  $('.color-circle').removeClass('active');
  $(this).addClass('active');
});

// CLICK POPUP ITEM
$(document).on('click', '.color-popup-item', function() {
  const target = $(this).data('target');

  $('#' + target).prop('checked', true).trigger('change');

  $('.color-popup-item').removeClass('active');
  $(this).addClass('active');

  $('.color-popup-overlay').fadeOut(200);
  $('.color-popup').fadeOut(200);
});


// OPEN
$(document).on('click', '.color-expand-btn', function() {
  $('.color-popup-overlay').fadeIn(200);
  $('.color-popup').fadeIn(200);
});

// CLOSE BUTTON
$(document).on('click', '.color-popup-close', function() {
  $('.color-popup-overlay').fadeOut(200);
  $('.color-popup').fadeOut(200);
});

// CLOSE ON OVERLAY CLICK
$(document).on('click', '.color-popup-overlay', function() {
  $('.color-popup-overlay').fadeOut(200);
  $('.color-popup').fadeOut(200);
});



      // Submit button click
      $(document).on('click', this.config.submitButtonSelector, function(e) {
        e.preventDefault();
        self.handleSubmit();
      });

      // Reset button click
      $(document).on('click', this.config.resetButtonSelector, function(e) {
        e.preventDefault();
        self.handleReset();
      });

      // Search input change
      $(document).on('input', 'input[name="q"]', function() {
        // Debounce search input changes
        if (self.state.debounceTimer) {
          clearTimeout(self.state.debounceTimer);
        }
        
        self.state.debounceTimer = setTimeout(function() {
          self.updateFilters();
        }, self.config.debounceDelay);
      });

      // Prevent form submission on Enter - require button click
      $(document).on('submit', this.config.formSelector, function(e) {
        e.preventDefault();
        self.handleSubmit();
      });
    },

    /**
     * Handle filter change (Year, Model, Color)
     */
    handleFilterChange: function($element) {
      const self = this;
      
      // Clear any existing debounce timer
      if (self.state.debounceTimer) {
        clearTimeout(self.state.debounceTimer);
      }

      // Debounce the AJAX request
      self.state.debounceTimer = setTimeout(function() {
        self.updateFilters();
      }, self.config.debounceDelay);
    },

    /**
     * Handle form submission - always goes to search page
     */
    handleSubmit: function() {
      const url = this.buildSearchUrl();
      console.log('Submitting to search page:', url);
      window.location.href = url;
    },

    /**
     * Handle reset button click
     */
    handleReset: function() {
      console.log('Resetting filters...');
      
      // Clear all filter values
      const $form = $(this.config.formSelector);
      $form.find('.vs-filter').val('');
      $form.find('.color-filter').prop('checked', false);
      
      this.handleFilterChange($(this));
    },

    /**
     * Build search URL for final form submission (without view parameter)
     */
    buildSearchUrl: function() {
      const $form = $(this.config.formSelector);
      const params = [];
      let url = this.config.collectionPageUrl;
      // Get search query
      const searchQuery = $form.find('input[name="q"]').val();
      if (searchQuery) {
        params.push('q=' + encodeURIComponent(searchQuery));
        url = this.config.searchPageUrl;
      }
      
      const year = $form.find('select[name="filter.p.m.custom.model_year"]').val();
if (year) {
  params.push('filter.p.m.custom.model_year=' + encodeURIComponent(year));
}



      // Get model value
      const model = $form.find('select[name="filter.p.m.custom.model"]').val();
      if (model) {
        params.push('filter.p.m.custom.model=' + encodeURIComponent(model));
      }
      // Get part type value
const partType = $form.find('select[name="filter.p.m.custom.part_type"]').val();
if (partType) {
  params.push('filter.p.m.custom.part_type=' + encodeURIComponent(partType));
}

// Get side value
const side = $form.find('select[name="filter.p.m.custom.side"]').val();
if (side) {
  params.push('filter.p.m.custom.side=' + encodeURIComponent(side));
}


      // Get color value
      const color = $form.find('input[name="filter.p.m.custom.color"]:checked').val();
      if (color) {
        params.push('filter.p.m.custom.color=' + encodeURIComponent(color));
      }
      url = url + '?';
      if (params.length > 0) {
        url += '?' + params.join('&');
      }

      return url;
    },

    /**
     * Build filter URL for AJAX requests (with view parameter)
     */
    buildFilterUrl: function() {
      const $form = $(this.config.formSelector);
      const params = [];
      let url = this.config.collectionPageUrl;
      // Get search query - ALWAYS include even if empty for search page
      const searchQuery = $form.find('input[name="q"]').val() || '';
      if (searchQuery) {
        params.push('q=' + encodeURIComponent(searchQuery));
        url = this.config.searchPageUrl;
      }
      
      const year = $form.find('select[name="filter.p.m.custom.model_year"]').val();
if (year) {
  params.push('filter.p.m.custom.model_year=' + encodeURIComponent(year));
}


      // Get model value
      const model = $form.find('select[name="filter.p.m.custom.model"]').val();
      if (model) {
        params.push('filter.p.m.custom.model=' + encodeURIComponent(model));
      }
      // Get part type value
const partType = $form.find('select[name="filter.p.m.custom.part_type"]').val();
if (partType) {
  params.push('filter.p.m.custom.part_type=' + encodeURIComponent(partType));
}

// Get side value
const side = $form.find('select[name="filter.p.m.custom.side"]').val();
if (side) {
  params.push('filter.p.m.custom.side=' + encodeURIComponent(side));
}


      // Get color value
      const color = $form.find('input[name="filter.p.m.custom.color"]:checked').val();
      if (color) {
        params.push('filter.p.m.custom.color=' + encodeURIComponent(color));
      }
      // Build URL - ALWAYS use search page
      url = url + '?';
      
      if (params.length > 0) {
        url += params.join('&') + '&';
      }
      
      url += this.config.viewParam;

      return url;
    },

    /**
     * Update filters via AJAX - ALWAYS from search page
     */
    updateFilters: function(callback) {
      const self = this;
      
      // Prevent multiple simultaneous requests
      if (self.state.isLoading) {
        return;
      }

      const url = self.buildFilterUrl();
      const $container = $(self.config.containerSelector);

      console.log('Fetching filters from search page:', url);

      // Set loading state
      self.state.isLoading = true;
      $container.addClass('loading');

      // AJAX request to get updated filters from SEARCH page
      $.ajax({
        url: url,
        type: 'GET',
        dataType: 'html',
        success: function(response) {
          console.log('Filters updated successfully from search page');
          
          // Replace the entire search bar with new HTML
          const $newContainer = $(response).find('#vehicle-search-bar');
          $container.replaceWith($newContainer);
          $('results-list').html($(response).find('results-list').html())
          // Re-initialize any needed functionality after DOM update
          self.reinitialize();
          
          // Execute callback if provided
          if (typeof callback === 'function') {
            callback();
          }
        },
        error: function(xhr, status, error) {
          console.error('Error updating filters:', error);
          console.error('Status:', status);
          console.error('Response:', xhr.responseText);
          
          // Show user-friendly error
          self.showError('Unable to update filters. Please try again.');
        },
        complete: function() {
          // Remove loading state
          self.state.isLoading = false;
          $(self.config.containerSelector).removeClass('loading');
        }
      });
    },

    /**
     * Re-initialize after DOM update
     */
   reinitialize: function() {
  console.log('Filters re-initialized');


    applyColorData();

},

    /**
     * Show error message
     */
    showError: function(message) {
      const $container = $(this.config.containerSelector);
      
      // Create error message
      const $error = $('<div class="vs-error-message">')
        .text(message)
        .css({
          'background': '#fee2e2',
          'color': '#991b1b',
          'padding': '12px 16px',
          'border-radius': '6px',
          'margin-top': '10px',
          'font-size': '14px'
        });
      
      // Remove any existing error
      $('.vs-error-message').remove();
      
      // Append error
      $container.append($error);
      
      // Auto-remove after 5 seconds
      setTimeout(function() {
        $error.fadeOut(function() {
          $(this).remove();
        });
      }, 5000);
    },

    /**
     * Check if any filters are active
     */
    hasActiveFilters: function() {
  const $form = $(this.config.formSelector);

  const year = $form.find('select[name="filter.p.m.custom.model_year"]').val();
  const model = $form.find('select[name="filter.p.m.custom.model"]').val();
  const partType = $form.find('select[name="filter.p.m.custom.part_type"]').val();
  const side = $form.find('select[name="filter.p.m.custom.side"]').val();
  const color = $form.find('input[name="filter.p.m.custom.color"]:checked').val();

  return !!(year || model || partType || side || color);
}

  };

 // Initialize when document is ready
// $(document).ready(function() {
//   VehicleSearch.init();


//     applyColorData();

// });

$(document).ready(function() {
  VehicleSearch.init();

  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      applyColorData();
    });
  });
});





  // Expose to window for debugging
  window.VehicleSearch = VehicleSearch;

})(jQuery);

